module.exports = __webpack_public_path__ + "static/Oprogramowanie-CRM-ac6ccfbe14bb605872062f2128d809fe.jpg";